module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-a936e783.png";